export default function ageCalculator(date: string): string {
    const actualDate = new Date();
    const dateOfBirth = new Date(date);
    let age = actualDate.getFullYear() - dateOfBirth.getFullYear();
    const monthDiff = actualDate.getMonth() - dateOfBirth.getMonth();
    const dayDiff = actualDate.getDate() - dateOfBirth.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age.toString();
}
